import { log } from '@intigral/utils';
import { useQuery } from '@tanstack/react-query';
import h from '../../../../helpers/common';
import { moodVodQueryOptions } from '../../../../hooks/useMoodVod';
import { __ } from '../../../../translations';
import { VodCarousel } from '../../../ui/VodCarousel';
import Loader from './Loader';
import NoContentBanner from './NoContentBanner';

const OnDemandVod = ({ category, onChangeMood, onItemClick }) => {
    const { data = [], isLoading: loading, error } = useQuery(moodVodQueryOptions(category));

    if (!loading && (!data || data.length === 0 || error)) {
        return <NoContentBanner onChangeMood={onChangeMood} />;
    }

    const title = {
        title: { [h.getLang()]: __(category.title_resource_key || 'mood_recommendation_categories_title') },
    };

    return (
        <>
            {loading ? (
                <Loader
                    length={6}
                    onChangeMood={onChangeMood}
                    title={__(category.title_resource_key || 'mood_recommendation_categories_title')}
                />
            ) : (
                <VodCarousel
                    content={data}
                    meta={title}
                    MoodChangeElement={{
                        // <Link to="#" className="seeAll" onClick={onChangeMood}>
                        //     {__('moods_change_mood_text')}
                        // </Link>
                        onClick: onChangeMood,
                        seeAllText: __('moods_change_mood_text'),
                        seeAllUrl: '#',
                    }}
                    onItemClick={onItemClick}
                />
            )}
        </>
    );
};

export default OnDemandVod;
